import Text from '@eversports/klimt-primitives/legacy/Text'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'

import { formatDate } from '../../helpers/format-date'
import { getCalendarDaysFromToday } from '../../helpers/get-calendar-days-from-today'
import { Localized } from '../../localization/react'

interface Props {
  date: string
  timeZone: string
}

// Color contrasts weren't working - now using colors from the nextjs design system palette
const MatchDate = ({ date, timeZone }: Props) => {
  const { language } = useSettingsContext()
  const daysFromToday = getCalendarDaysFromToday(new Date(date), timeZone)

  if (daysFromToday === 0) {
    return (
      <Text
        variant="small"
        sx={{ fontWeight: 'bold', color: 'red', backgroundColor: '#f9ebeb', paddingX: 2, paddingY: 0.5 }}
      >
        <Localized id="today" />
      </Text>
    )
  }

  if (daysFromToday === 1) {
    return (
      <Text
        variant="small"
        sx={{ fontWeight: 'bold', color: 'tertiarySelected', backgroundColor: '#fdf2e7', paddingX: 2, paddingY: 0.5 }}
      >
        <Localized id="tomorrow" />
      </Text>
    )
  }

  return <Text variant="small">{formatDate(language, date, timeZone)}</Text>
}

export default MatchDate
